import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Box1Component } from "src/app/fitur-26/layout/boxes";
import { AngularProgressBarComponent } from "./components";
import { CustomRouteService } from 'src/app/pages/custom-route/services';
import { PlannerDayStateService } from 'src/app/pages/custom-route/shared/planner/services';
import dayjs from 'dayjs';
import { ProfiledRouteInfo } from './services';
import { TranslationService } from 'src/app/services';
@Component({
  selector: 'app-info-route',
  standalone: true,
  imports: [
    TranslateModule,
    Box1Component,
    AngularProgressBarComponent,
],
  templateUrl: './info-route.component.html',
  styleUrls: ['./info-route.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InfoRouteComponent {  
  // Service injections
  private _customRouteService = inject(CustomRouteService);
  private _plannerDayStateService = inject(PlannerDayStateService);
  private _profiledRouteInfoService = inject(ProfiledRouteInfo);
  private _translationService = inject(TranslationService);
  
  // State service signals
  private _customRouteData = this._customRouteService.customRouteData;
  private _dayToShowIndex = this._plannerDayStateService.dayToShowIndex;
  protected profiledRouteInfo = this._profiledRouteInfoService.profiledRouteInfo;
  protected selectedLanguage = this._translationService.selectedLanguage;
  private _routeToken = this._customRouteService.token;
  
  // Computed properties
  protected dailyStats = computed(() => {
    const routeData = this._customRouteData();
    console.log('Custom Route Data in InfoRouteComponent:', routeData);
    if (!routeData || !routeData.stats) return null;

    const dailyStats = routeData.stats.dailyStats;
    return dailyStats ? dailyStats[this._dayToShowIndex()] : null;
  });

  protected globalStats = computed(() => {
    const routeData = this._customRouteData();
    if (!routeData || !routeData.stats) return null;

    return routeData.stats.globalStats;
  });
  
  protected dailyPercentageWalkingVSTransport = computed(() => {
    const totalTransportDistance = this.dailyStats().publicTransportDistance;
    const totalTransportDistanceNumber = totalTransportDistance ? parseFloat(totalTransportDistance.split(" ")[0]) : 0;
    const totalWalkingDistance = this.dailyStats().walkingDistance;
    const totalWalkingDistanceNumber = totalWalkingDistance ? parseFloat(totalWalkingDistance.split(" ")[0]) : 0;
    const totalDistance = totalTransportDistanceNumber + totalWalkingDistanceNumber;
    if (totalDistance === 0) return 0;
    return Math.round((totalWalkingDistanceNumber / totalDistance) * 100);
  });

  protected dailyWalkingDistance = computed(() => {
    const totalWalkingDistance = this.dailyStats()?.walkingDistance;
    if (!totalWalkingDistance) return { value: 0, unit: 'km' };
    const [valueStr, unit] = totalWalkingDistance.split(" ");
    const value = Math.round(parseFloat(valueStr) * 10) / 10;
    return { value, unit };
  });

  protected dailyTransportDistance = computed(() => {
    const totalTransportDistance = this.dailyStats()?.publicTransportDistance;
    if (!totalTransportDistance) return { value: 0, unit: 'km' };
    const [valueStr, unit] = totalTransportDistance.split(" ");
    const value = Math.round(parseFloat(valueStr) * 10) / 10;
    return { value, unit };
  });
  
  protected carbonEmissions = computed(() => {
    const emissions = this.dailyStats()?.estimatedEmissions;
    if (!emissions) return { value: 0, unit: 'kg' };
    const valueStr = emissions.split("kg")[0];
    const value = Math.round(parseFloat(valueStr) * 10) / 10;
    return value * 1000
  });
  
  protected priceEstimation = computed(() => {
    const price = this.dailyStats()?.estimatedPrice;
    if (!price) return { value: 0, unit: '€' };
    const [valueStr, unit] = price.split(" ");
    const value = Math.round(parseFloat(valueStr) * 10) / 10;
    return { value, unit: '€' };
  });
  
  protected getDateDailyRoute(dateString: string): { day: string; month: string } {
    const date = dayjs(dateString);
    return {
      day: date.format('DD'),
      month: date.format('MMM')
    };
  }
  
  getProfiledInfoEffect = effect(() => {
    const routeToken = this._routeToken();
    if (!routeToken) return;
    
    this._profiledRouteInfoService.getProfiledRouteInfo(routeToken);
  }, { allowSignalWrites: true });
}
